import React from "react";
import SEO from "@/components/SEO";
import NewsArticleLayout from "@/components/NewsArticleLayout";

const DentalTreatmentCostsAustraliaPage = () => {
  return (
    <NewsArticleLayout
      title="How Much Does Dental Treatment Cost in Australia? A Practical Guide"
      date="February 2026"
      author="Y3 Smiles Dental"
    >
      <SEO title="Dental Costs in Australia | Broadmeadows Dentist Guide" description="Understand typical dental costs in Australia and how early care saves money long-term." image="/og-reception.jpg" />
      <p>
        Dental treatment costs can vary depending on complexity, materials, and clinical needs. Early care often reduces
        long-term costs by preventing problems from worsening.
      </p>

      <section className="space-y-3">
        <h2 className="text-2xl font-semibold">Indicative Australian Price Ranges</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Check-up: $80 – $180</li>
          <li>Scale and clean: $150 – $300</li>
          <li>Filling: $200 – $350 (up to $550 for complex cases)</li>
          <li>Root canal: $1,500 – $3,000</li>
          <li>Crown: $1,400 – $2,400</li>
          <li>Tooth extraction: $250 – $600 (surgical may cost more)</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-semibold">Pros of Early Care</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Smaller issues are cheaper to fix</li>
          <li>Less time in the dental chair</li>
          <li>Lower risk of emergency treatment</li>
        </ul>
        <h2 className="text-2xl font-semibold">Cons of Delayed Care</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Higher likelihood of complex procedures</li>
          <li>Greater discomfort and time off work or school</li>
          <li>More costly, multi-step treatment plans</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-semibold">Local Service Area</h2>
        <p>
          We support patients across Broadmeadows and nearby suburbs within 10 km, including Glenroy, Dallas, Meadow
          Heights, Jacana, Coolaroo, Roxburgh Park, Campbellfield, Fawkner, Westmeadows, and Hadfield.
        </p>
      </section>

      <div className="bg-neutral-50 border border-primary/10 rounded-2xl p-6 text-sm text-neutral-700">
        ⚠️ Educational only. All costs are indicative. Final treatment decisions and fees depend on individual assessment,
        in line with AHPRA advertising guidelines.
      </div>
    </NewsArticleLayout>
  );
};

export default DentalTreatmentCostsAustraliaPage;
